/**
 * Normalize /auth/me (or login) payload into Redux user shape with string[] roles.
 */
export function normalizeStaffUser(me) {
  if (!me) {
    return null;
  }

  const { session: _session, ...rest } = me;

  const roles = Array.isArray(rest.roles)
    ? rest.roles.map((role) => (typeof role === 'string' ? role : role.name))
    : [];

  return { ...rest, roles };
}
